/** Dashboard tab ids and page padding tokens. */
export const TAB_COMPLETED = 'completed';
export const TAB_WAITING = 'waiting';
export const PAGE_PADDING_BATTLEFIELD = 1.5;
export const PAGE_PADDING_DESKTOP = 3;

export const countWaitingTasks = (delegatedTasksByPerson) =>
  Object.values(delegatedTasksByPerson ?? {}).reduce(
    (total, tasks) => total + (tasks?.length ?? 0),
    0,
  );

/** Aggregeer uren per project uit barData. */
export const aggregateProjectHours = (barData) =>
  barData.reduce((acc, day) => {
    day.projects.forEach((p) => {
      const key = p.projectId ?? p.name;
      const existing = acc.find(
        (x) => (x.projectId ?? x.name) === key,
      );
      if (existing) {
        existing.hours += p.hours;
      } else {
        acc.push({
          projectId: p.projectId,
          name: p.name,
          hours: p.hours,
          colorIndex: p.colorIndex,
        });
      }
    });
    return acc;
  }, []);

export const buildDashTabs = (
  isBattlefield,
  t,
  waitingCount,
  completedCount,
) => {
  const waitingTab = {
    id: TAB_WAITING,
    label: t('dashboard.waiting', 'Wachtend'),
    count: waitingCount,
  };
  const completedTab = {
    id: TAB_COMPLETED,
    label: t('dashboard.completed', 'Voltooid'),
    count: completedCount,
  };

  return isBattlefield
    ? [waitingTab, completedTab]
    : [completedTab, waitingTab];
};
